import { api } from '@/api/api'

export async function fetchOrderCode({
    email,
    orderNumber,
}: {
    email: string
    orderNumber: string
}): Promise<string> {
    const {
        data: { orderCode },
    } = await api.get(`order/start/${orderNumber}/${email}`)

    return orderCode
}
